import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CanManageBillingPermissionForAccount } from '../../../features/permissions/queries/generated/fragments';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetCanManageBillingPermissionQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetCanManageBillingPermissionQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, permissions?: { __typename?: 'AccountPermissions', canManageBilling: boolean } | null } | null };


export const GetCanManageBillingPermission = /*#__PURE__*/ gql`
    query GetCanManageBillingPermission($accountId: ID!) {
  account(accountId: $accountId) {
    id
    ...CanManageBillingPermissionForAccount
  }
}
    ${CanManageBillingPermissionForAccount}` as unknown as DocumentNode<GetCanManageBillingPermissionQuery, GetCanManageBillingPermissionQueryVariables>;

          

          export const useGetCanManageBillingPermissionQuery = (options?:QueryHookOptions<GetCanManageBillingPermissionQuery, GetCanManageBillingPermissionQueryVariables>) => useQuery(GetCanManageBillingPermission, options);

          

          export type GetCanManageBillingPermissionQueryOptions = QueryHookOptions<GetCanManageBillingPermissionQuery, GetCanManageBillingPermissionQueryVariables>;

          

          export const useGetCanManageBillingPermissionLazyQuery = (options?:LazyQueryHookOptions<GetCanManageBillingPermissionQuery, GetCanManageBillingPermissionQueryVariables>) => useLazyQuery(GetCanManageBillingPermission, options);

          

          export type GetCanManageBillingPermissionQueryResult = ReturnType<typeof useGetCanManageBillingPermissionQuery>;

          
